import { useFormik } from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CardBody } from '../../../../components/card/card';
import { GetApprovalGroupList } from '../../../../store/Ame/approvalGroupSlice';
import {
  AddAmeActionRule,
  GetAmeActionRule,
  DeleteAmeActionRule,
} from '../../../../store/Ame/ameActionRuleSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import Loading from '../../../../components/Shared/Loader/Loading';
import showConfirmation from '../../../../components/Shared/Alert/Confirmation';
import NoData from '../../../../components/NoData/NoData';

function AddAmeAction({ ruleId, onclose }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetApprovalGroupList());
    dispatch(GetAmeActionRule(ruleId));
  }, [dispatch, ruleId]);
  const {
    ApprovalGroupList,
    loading: loading2,
    error: error2,
  } = useSelector((state) => state.ApprovalGroup);
  const { ActionRuleListByRuleId, loading, error } = useSelector((state) => state.AmeActionRule);

  const formik = useFormik({
    initialValues: {
      ApprovalType: '1', // hide show Element  and validation Dynamic Only
      supperVisorLevel: '',
      approvalGroupId: '',
      order: '',
    },
    validationSchema: Yup.object().shape({
      ApprovalType: Yup.string()
        .required(() => t('Required'))
        .notOneOf(['إختر', 'Choose'], 'Required'),

      supperVisorLevel: Yup.string().when('ApprovalType', {
        is: '0',
        then: () =>
          Yup.string()
            .required(() => t('Required'))
            .notOneOf(['إختر', 'Choose'], 'Required'),
      }),

      approvalGroupId: Yup.string().when('ApprovalType', {
        is: '1',
        then: () =>
          Yup.string()
            .required(() => t('Required'))
            .notOneOf(['إختر', 'Choose'], 'Required'),
      }),

      order: Yup.string().when('ApprovalType', {
        is: '1',
        then: () => Yup.string().required(() => t('Required')),
      }),
    }),
    onSubmit: (values) => {
      dispatch(
        AddAmeActionRule({
          ruleId: ruleId,
          supperVisorLevel:
            formik.values.ApprovalType === '0' ? formik.values.supperVisorLevel : null,
          approvalGroupId:
            formik.values.ApprovalType === '1' ? formik.values.approvalGroupId : null,
          order: formik.values.ApprovalType === '1' ? formik.values.order : null,
        })
      )
        .unwrap()
        .then(() => {
          formik.resetForm();
          CustomAlert({ action: 'Add' });
          dispatch(GetAmeActionRule(ruleId));
        })
        .catch((error) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    },
  });

  var isSupervisor = false;
  ActionRuleListByRuleId?.map((item) => {
    if (item.supperVisorLevel !== null) {
      isSupervisor = true;
    }
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const handleDeleteActionRule = (item) => {
    showConfirmation(t('MsgConfirm'), () => {
      dispatch(DeleteAmeActionRule(item.id))
        .unwrap()
        .then(() => {
          dispatch(GetAmeActionRule(ruleId));
          CustomAlert({ action: 'Add' });
        })
        .catch((error) => {
          console.log(error);
          CustomAlert({ action: 'Error' });
        });
    });
  };

  return (
    <>
      <Loading loading={loading || loading2} error={error || error2} Type="Dots">
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-6">
                <div className="form-group mb-3">
                  <label className="form-label">{t('ApprovalGroup')}</label>
                  <Form.Select
                    className="form-select"
                    name="ApprovalType"
                    onChange={formik.handleChange}
                    value={formik.values.ApprovalType}
                    isInvalid={formik.touched.ApprovalType && formik.errors.ApprovalType}>
                    <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                    {!isSupervisor && (
                      <option value="0">
                        {i18n.language === 'ar' ? 'مدير مباشر ' : 'supervisor'}
                      </option>
                    )}

                    <option value="1">
                      {i18n.language === 'ar' ? 'قائمة موافقات' : 'list Approvals'}
                    </option>
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.ApprovalType}
                  </Form.Control.Feedback>
                </div>
              </div>

              {formik.values.ApprovalType === '0' && (
                <div className="col-6">
                  <div className="form-group mb-3">
                    <label className="form-label">{t('SuperVisorLevel')}</label>
                    <Form.Select
                      className="form-select"
                      name="supperVisorLevel"
                      onChange={formik.handleChange}
                      value={formik.values.supperVisorLevel}
                      isInvalid={formik.touched.supperVisorLevel && formik.errors.supperVisorLevel}>
                      <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                      <option value="1">{i18n.language === 'ar' ? ' الأول ' : 'the first'}</option>

                      <option value="2">
                        {i18n.language === 'ar' ? 'الثاني ' : 'the second '}
                      </option>

                      <option value="3">{i18n.language === 'ar' ? 'الثالث' : 'the third'}</option>

                      <option value="4">{i18n.language === 'ar' ? 'الرابع ' : 'the fourth'}</option>
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.supperVisorLevel}
                    </Form.Control.Feedback>
                  </div>
                </div>
              )}

              {formik.values.ApprovalType === '1' && (
                <>
                  <div className="col-4 ">
                    <div className="form-group mb-3">
                      <label className="form-label">{t('ApprovalGroup')}</label>
                      <Form.Select
                        className="form-select"
                        name="approvalGroupId"
                        onChange={formik.handleChange}
                        value={formik.values.approvalGroupId}
                        isInvalid={formik.touched.approvalGroupId && formik.errors.approvalGroupId}>
                        <option value={null}>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

                        {ApprovalGroupList?.map((item) => (
                          <option key={item.id} value={item.id}>
                            {i18n.language === 'ar' ? item.name2 : item.name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.approvalGroupId}
                      </Form.Control.Feedback>
                    </div>
                  </div>

                  <div className="col-2 ">
                    <div className="form-group mb-3">
                      <label className="form-label">{t('Order')}</label>
                      <Form.Control
                        className="form-control"
                        type="number"
                        name="order"
                        onChange={formik.handleChange}
                        value={formik.values.order}
                        isInvalid={formik.touched.order && formik.errors.order}
                      />
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.order}
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="text-center">
              <button
                disabled={formik.isSubmitting}
                type="submit"
                className="btn me-1 btn-theme mb-1">
                {formik.isSubmitting ? (
                  <div className="spinner-border spinner-border-sm me-2"></div>
                ) : (
                  <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                )}
                {t('Add')}
              </button>
              <button type="button" className=" btn me-1 btn-default mb-1" onClick={onclose}>
                <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
              </button>
            </div>
          </Form>

          <div className="mb-2" />

          <>
            {ActionRuleListByRuleId?.length > 0 ? (
              <div className="table-responsive rounded-2 text-center  ">
                <table className="table table-hover mb-0">
                  <thead className="bg-theme bg-opacity-40">
                    <tr>
                      <th> {t('#')}</th>
                      <th> {t('Name')}</th>
                      <th> {t('Order')}</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {ActionRuleListByRuleId &&
                      ActionRuleListByRuleId?.slice()
                        ?.sort((a, b) => a?.order - b?.order)
                        ?.map((item, idx) => (
                          <tr key={item.id}>
                            <td className="align-middle">{++idx}</td>
                            <td className="align-middle">
                              {i18n.language === 'ar' ? item.name2 : item.name}
                            </td>
                            <td className="align-middle">
                              <span>
                                {item.order === 1 && (
                                  <i className="fa-lg bi bi-1-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 2 && (
                                  <i className="fa-lg bi bi-2-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 3 && (
                                  <i className="fa-lg bi bi-3-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 4 && (
                                  <i className="fa-lg bi bi-4-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 5 && (
                                  <i className="fa-lg bi bi-5-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 6 && (
                                  <i className="fa-lg bi bi-6-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 7 && (
                                  <i className="fa-lg bi bi-7-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 8 && (
                                  <i className="fa-lg bi bi-8-circle text-theme"></i>
                                )}
                              </span>
                              <span>
                                {item.order === 9 && (
                                  <i className="fa-lg bi bi-9-circle text-theme"></i>
                                )}
                              </span>
                            </td>
                            <td className="align-middle">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger btn-lg m-0"
                                onClick={() => handleDeleteActionRule(item)}>
                                <i className="fas fa-trash-alt fa-fw fa-lg"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData />
            )}
          </>
        </CardBody>
      </Loading>
    </>
  );
}

export default AddAmeAction;
